<template>
  <div class="good-item">
    <div style="">
      <div class="good-img">
        <a @click="openProduct(msg.id)">
          <img :src="msg.defaultImage" :alt="msg.name" :key="msg.defaultImage">
        </a>
      </div>
      <h6 class="good-title" v-html="msg.name">{{msg.name}}</h6>
      <!-- <h3 class="sub-title ellipsis">{{msg.subTitle}}</h3> -->
      <div class="good-price pr">
        <div class="ds pa">
          <a @click="openProduct(msg.id)">
            <y-button text="查看详情" style="margin: 0 5px"></y-button>
          </a>
          <y-button text="加入购物车"
                    style="margin: 0 5px"
                    @btnClick="showModal(msg.id,msg.settlementPrice,msg.name,msg.defaultImage,msg.frontendPropertyInfo,msg.productSpecs)"
                    classStyle="main-btn"
          ></y-button>
        </div>
        <p><span style="font-size:14px">采购价：￥</span>{{Number(msg.settlementPrice).toFixed(2)}}</p>
        <h5 style="font-size:14px;color:#bdbdbd">原价：￥{{Number(msg.sellPrice).toFixed(2)}}</h5>
      </div>
    </div>
     <div class="modal" v-if="showSpecModal">
      <div class="modal-title">请选择规格</div>
       <div class="proper-box">
          <div class="proper" v-for="(item,i) in msg.frontendPropertyInfo"  :key="i">
            <div class="title">{{item.name}}</div>
            <div class="items">
              <div   v-for="(p,j) in item.propertyDetails"  :key="j" :class='["item",p.current ? "active" : "1"]'   @click="selAttr(i,j)"> {{p.name}}</div>
            </div>
          </div>
        </div>
        <div class="num-box">
          <span class="params-name">数量</span>
          <buy-num @edit-num="editNum" :limit="Number(stockNum)"></buy-num>
        </div>
        <div class="anniu">
          <y-button text="取消"
                    style="background: #f9f9f9;border:1px solid #f9f9f9;color:#000"
                    @btnClick="close()"
                    classStyle="main-btn "
          ></y-button>
          <y-button text="确认"
                   
                    @btnClick="addSpecCart(msg.id,msg.settlementPrice,msg.name,msg.defaultImage)"
                    classStyle="main-btn "
          ></y-button>
        </div>
        
    </div>
  </div>
 
</template>
<script>
  
  import YButton from '@/components/yButton'
  import BuyNum from '@/components/buynum'
  import {mapGetters, mapActions, mapMutations, mapState} from 'vuex'
  import { getStore } from '@/utils/storage'
  export default {
    props: {
      msg: {
        salePrice: 0
      }
    },
    data () {
      return {
        showSpecModal:false,
        num:1,
        stockNum:1,
        selectIndexArray:[],
      }
    },
    methods: {
      ...mapMutations(['ADD_CART', 'ADD_ANIMATION', 'SHOW_CART']),
      openProduct (id) {
        window.open('//' + window.location.host + '/#/goodsDetails?productId=' + id)
      },
      editNum (num) {
        this.num = num
      },
      showErrorMsg(msg){
        this.$message({
              message: msg,
              type: 'error',
              customClass: 'c-msg',
              duration: 1000,
              showClose: true
            })
      },
      checkAttr(){

        var productSpecs = this.msg.productSpecs; //原始规格数据
        //判断是否所以规格组都选中
        var frontendPropertyInfo = this.msg.frontendPropertyInfo;
        var tips = ''
        var selectAttrid = []

        for (var i = 0; i < frontendPropertyInfo.length; i++) {
            if (this.selectIndexArray.indexOf(i) < 0) {
                tips = '请选择' + frontendPropertyInfo[i].name

            }
            var propertyDetails = frontendPropertyInfo[i].propertyDetails;
            for (var j = 0; j < propertyDetails.length; j++) {
                if (propertyDetails[j].current) {
                    selectAttrid.push(propertyDetails[j].id)
                }
            }
        }
        if (tips) {
            this.showErrorMsg(tips)
            return false
        }

        var specId = productSpecs[0].id;
        //从原始数据中找到相应规格组
        for (var i = 0; i < productSpecs.length; i++) {
            var tmp = []
            for (var y = 0; y < productSpecs[i].productPropertyInfo.length; y++) {
                tmp.push(productSpecs[i].productPropertyInfo[y].vid);
            }
            if (tmp.sort().toString() == selectAttrid.sort().toString()) {
                specId = productSpecs[i].id //规格id
                if (productSpecs[i].quantity <= 0) {
                    this.showErrorMsg('该规格库存不足')
                    return;
                }
            }
        }
        if (specId == 0) {
          this.showErrorMsg('请选择规格')
          return false
        }
        return specId 

      },
      selAttr (index,jj) {
        var count = this.msg.frontendPropertyInfo[index].propertyDetails.length;

        for (var i = 0; i < count; i++) {
            this.msg.frontendPropertyInfo[index].propertyDetails[i].current = false;
        }
        this.msg.frontendPropertyInfo[index].propertyDetails[jj].current =true


        var selectIndexArray = this.selectIndexArray
        if (selectIndexArray.indexOf(index) < 0) {
            selectIndexArray.push(index)
        }
        var selectAttrid = []
        for (var i = 0; i < this.msg.frontendPropertyInfo.length; i++) {
            var propertyDetails = this.msg.frontendPropertyInfo[i].propertyDetails;
            for (var j = 0; j < propertyDetails.length; j++) {
                if (propertyDetails[j].current) {
                    selectAttrid.push(propertyDetails[j].id)
                }
            }
        }
        var product = this.msg

        var stockNum = this.stockNum
       
        //var settlementPrice = this.settlementPrice    
       // var sellPrice = this.sellPrice
            //从原始数据中找到相应规格组
        for (var i = 0; i < product.productSpecs.length; i++) {
            var tmp = []
            for (var y = 0; y < product.productSpecs[i].productPropertyInfo.length; y++) {
                tmp.push(product.productSpecs[i].productPropertyInfo[y].vid);
            }
            if (tmp.sort().toString() == selectAttrid.sort().toString()) {
               // settlementPrice = product.productSpecs[i].settlementPrice
                stockNum = product.productSpecs[i].quantity
               // sellPrice = product.productSpecs[i].sellPrice
            }
        }
        this.stockNum = stockNum
        this.selectIndexArray = selectIndexArray
        //this.settlementPrice = settlementPrice
       // this.sellPrice = sellPrice
        this.$forceUpdate();
      },
      close(){
         this.showSpecModal = false
      },
      showModal(id, price, name, img,frontendPropertyInfo,productSpecs){
       
        if(frontendPropertyInfo.length){
          this.showSpecModal = true
        }else{
          let specId = productSpecs[0].id
          let specName = productSpecs[0].specName
          this.addCart(id, price, name, img,specId,specName,1);
        }
      },
      addSpecCart(id, price, name, img){
        let specId= this.checkAttr()
         if(!specId){
           return
         }
        let specName = ''
        this.msg.productSpecs.forEach((item) => {
          if (item.id === specId){
            specName = item.specName
          }
        })
         
        this.addCart(id, price, name, img, specId, specName,this.num)
      },
      addCart (id, price, name, img, specId, specName,num) {
         this.ADD_CART({
            productId: id,
            settlementPrice: price,
            name: name,
            defaultImage: img,
            num: num,
            specId: specId,
            specName:specName
          })
          // 加入购物车动画
          var dom = event.target
          // 获取点击的坐标
          let elLeft = dom.getBoundingClientRect().left + (dom.offsetWidth / 2)
          let elTop = dom.getBoundingClientRect().top + (dom.offsetHeight / 2)
          let imgs= "http://localhost:8888/static/images/logo.png"
          // 需要触发
          this.ADD_ANIMATION({moveShow: true, elLeft: elLeft, elTop: elTop, img: imgs})
          if (!this.showCart) {
            this.SHOW_CART({showCart: true})
          }
      }
    },
    computed: {
      ...mapState(['isLogined', 'showMoveImg', 'showCart'])
    },
    mounted () {
    },
    components: {
      YButton,
      BuyNum, 
    }
  }
</script>
<style lang="stylus">
  @import '../common/stylus/common'
 

  .good-item {
    background: #fff;
    width: 25%;
    transition: all .5s;
    height: 430px;
    &:hover {
      transform: translateY(-3px);
      box-shadow: 1px 1px 20px #999;
      .good-price p {
        // display: none;
      }
      .ds {
        display: flex;
        
      }
    }
    .ds {
      align-items center;
      justify-content center;
      width: 100%;
      display: none;
      margin-top 60px;
    }

    .good-img {
      img {
        margin: 15px auto 10px;
        width 266px;
        height 266px;
        display: block;
      }
    }
    .good-price {
      margin: 15px 0;
      height: 30px;
      text-align: center;
      line-height: 30px;
      color: #d44d44;
      font-family: Arial;
      font-size: 18px;
      font-weight: 700;
    }
    .good-title {
      line-height: 1.2;
      font-size: 16px;
      color: #424242;
      margin: 0 auto;
      padding: 0 14px;
      text-align: center;
      overflow: hidden;
    }
    h3 {
      text-align: center;
      line-height: 1.2;
      font-size: 12px;
      color: #d0d0d0;
      padding: 10px;
    }
  }
  a{
    font-style: normal;
    text-decoration: none;
    color: #5079d9;
    cursor: pointer;
    transition: all .15s ease-out;
  }
  .modal{
    width 300px;
    height 400px;
    position relative;
    top:-370px;
    margin auto;
    background #fff;

  }
  .modal-title{
    padding 10px
    text-align center
    font-size 15px
  }
  .num-box{
    padding: 29px 0 8px 10px;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
  }
   
  .proper-box{
    .proper{
      .title{
        padding 10px;
      }
      .items{
        display: flex;
        flex-wrap: wrap;
        margin-top: 5rpx;
        margin-left: -20rpx;
        .item{
          font-size: 14px;
          min-width: 100px;
          height: 40px;
          margin-left: 5px;
          border-radius: 5px;
          text-align: center;
          line-height: 40px;
          margin-top: 10rpx;
          border 1px solid #ebebeb;
        }
        .active{
          background: #5c81e3;
          color: #fff;
        }
      }
    
    }
  }
.anniu{
  margin-top 50px
  display flex
  justify-content space-around
} 
</style>



// WEBPACK FOOTER //
// mallGoods.vue?c439a932